/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React, { useState, useEffect, useRef } from 'react'; // eslint-disable-next-line
import { copiriAxiosPost, copiriAxiosGet, copiriPortalRequest } from '../api/api'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
import FormGroupInput from '../common/FormGroupInput';
import AddressMap from './AddressMap';
import 'leaflet/dist/leaflet.css';
import 'leaflet.tilelayer.colorfilter';
import L from 'leaflet'; // eslint-disable-next-line
import 'react-leaflet-fullscreen/dist/styles.css';
// eslint-disable-next-line
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'react-bootstrap';
import icon from '../../assets/img/lodges/masonic_craft.png'; // eslint-disable-next-line
import iconShadow from '../../assets/img/lodges/masonic_craft.png'; // eslint-disable-next-line
import CopiriLoader from '../common/CopiriLoader';
import { genPageData } from '../langconfig/langconfig'; // eslint-disable-next-line
import loader_image from '../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
const LodgeAddressModal = props => {
	const [orgName, setOrgName] = useState(''); // eslint-disable-next-line
	const [name, setName] = useState(''); // eslint-disable-next-line
	const [nameError, setNameError] = useState(''); // eslint-disable-next-line
	const [namePlaceHolder, setNamePlaceHolder] = useState('');
	const [streetAddress, setStreetAddress] = useState('');
	const [streetAddress2, setStreetAddress2] = useState('');
	const [streetAddress3, setStreetAddress3] = useState(''); // eslint-disable-next-line
	const [streetAddressError, setStreetAddressError] = useState('');
	const [country, setCountry] = useState('');
	const [state, setState] = useState('');
	const [state2, setState2] = useState('');
	const [city, setCity] = useState('');
	const [postalCode, setPostalCode] = useState(''); // eslint-disable-next-line
	const [cityError, setCityError] = useState(''); // eslint-disable-next-line
	const [stateError, setStateError] = useState(''); // eslint-disable-next-line
	const [countryError, setCountryError] = useState(''); // eslint-disable-next-line
	const [postalCodeError, setPostalCodeError] = useState(''); // eslint-disable-next-line
	const [id, setId] = useState();
	const [disableStreet2, setDisableStreet2] = useState(false);
	const [disableStreet3, setDisableStreet3] = useState(false); // eslint-disable-next-line
	const [showHideLoader, setShowHideLoader] = useState(false); // eslint-disable-next-line
	const [stateData, setStateData] = useState([]);
	const [checkStateData, setCheckStateData] = useState(false);
	const [disabledUpdate, setDisabledUpdate] = useState(true);
	const [disabledValidate, setDisabledValidate] = useState(true);
	const [revalidateMessage, setRevalidateMessage] = useState(false);
	const [pageLanguageContent, setPageLanguageContent] = useState([]);
	const [countryData, setCountryData] = useState([]);
	const [showValidateLoader, setShowValidateLoader] = useState(false);
	const [showUpdateDataLoader, setShowUpdateDataLoader] = useState(false);
	let map = useRef(null); // eslint-disable-next-line
	const egMap = useRef(); // eslint-disable-next-line
	const [lat, setLat] = useState('');
	const [long, setLong] = useState('');
	const filter = ['bright:101%', 'contrast:101%', 'hue:23deg', 'saturate:225%'];
	const [dcolor, setDcColor] = useState('transparent');
	/* input validation constants */
	const [validation, setValidation] = useState({
		error_city: '',
		error_postal_code: '',
		error_state: '',
		error_country: ''
	});
	useEffect(() => {
		if (props.id && props.showHide) {
			setLat('');
			setLong('');
			setId(props.id);
			getLodgeAddress(props.id);
			getCountryData();
			var checkData = JSON.parse(localStorage.getItem('idiom'));
			if (checkData['CLD']) {
				setPageLanguageContent(checkData['CLD']);
			}
			setDisabledValidate(true);
			setRevalidateMessage('');
		}
		// eslint-disable-next-line
	}, [props]);

	// function to get the lodge map data
	function getCountryData() {
		copiriPortalRequest('/canon/countries/common', config.app_version, 'get')
			.then(response => {
				if (response.data.length > 0) {
					setCountryData(response.data);
				}
			})
			.catch(error => {});
	}

	/* initial function to get the Address data */
	function getLodgeAddress(id) {
		setShowHideLoader(true);
		const formdata = new FormData();
		formdata.append('action', 'load_address');
		formdata.append('id', id);
		copiriAxiosPost(config.portal_url, formdata)
			.then(response => {
				getStatesData(response.data.address.country_id, response.data.address.state_id);
				setState2(response?.data?.address?.state_name);
				setOrgName(
					response.data.address.street_1 +
						'. ' +
						response.data.address.city +
						', ' +
						response.data.address.state_abbrev +
						' ' +
						response.data.address.post_code +
						' ' +
						response.data.address.country_name
				);
				if (response.data.address.latitude && response?.data?.address?.latitude !== '') {
					setLat(response?.data?.address?.latitude);
					setLong(response?.data?.address?.longitude);
					document.getElementById('center_lat').value = response?.data?.address?.latitude;
					document.getElementById('center_long').value = response?.data?.address?.longitude;
				}
				setStreetAddress(response?.data?.address?.street_1);
				setStreetAddress2(response?.data?.address?.street_2);
				setStreetAddress3(response?.data?.address?.street_3);
				setCity(response?.data?.address?.city);
				setPostalCode(response?.data?.address?.post_code);
				setName(response?.data?.address?.facility);

				if (response.data.address.street_1 === '') {
					setDisableStreet2(true);
				}
				if (response.data.address.street_2 === '') {
					setDisableStreet3(true);
				}
				setCountry(response.data.address.country_id);
				setShowHideLoader(false);
				L.tileLayer
					.colorFilter('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
						attribution: null,
						transparent: true,
						url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
						filter: filter
					})
					.addTo(map.current.leafletElement);
				map.invalidateSize();
			})
			.catch(error => {
				setShowHideLoader(false);
			});
	}

	let DefaultIcon = L.icon({
		iconUrl: icon,
		iconAnchor: null,
		popupAnchor: [-0, -0],
		shadowAnchor: null,
		iconSize: [45, 65]
	});
	L.Marker.prototype.options.icon = DefaultIcon;

	/* function to get the states Data based on country id */
	function getStatesData(country_id, state_id, type = false) {
		if (type) {
			let spilit_country = country_id.split('_');
			if (spilit_country[1]) {
				country_id = spilit_country[1];
			}
		}
		setShowHideLoader(true);
		var url = config.portal_url + '/?content_request=states&cid=' + country_id;
		copiriAxiosGet(url)
			.then(response => {
				if (response.data.length > 0) {
					setStateData(response.data);
					setCheckStateData(true);
					setState(state_id);
				} else {
					setStateData([]);
					setCheckStateData(false);
					setState2('');
				}
				setShowHideLoader(false);
			})
			.catch(error => {
				setShowHideLoader(false);
			});
	}

	/* function to change country and state data */
	const changeCountry = event => {
		setCountry(event.target.value);
		getStatesData(event.target.value, '', true);
		enableDisableValidate();
	};

	/* function to update the address */
	function updateAddress() {
		const formdata = new FormData();
		formdata.append('action', 'address_update');
		formdata.append('org_id', id);
		formdata.append('address_1', streetAddress);
		formdata.append('address_2', streetAddress2);
		formdata.append('address_3', streetAddress3);
		formdata.append('facility', name);
		formdata.append('city', city);
		var stateText = '';
		var state1 = document.getElementById('selectState');
		if (state1) {
			stateText = state1.options[state1.selectedIndex].text;
		}

		if (!checkStateData) {
			formdata.append('state_tt', state2);
			formdata.append('state_dd', '');
		} else {
			formdata.append('state_tt', stateText);
			formdata.append('state_dd', state);
		}
		formdata.append('post_code', postalCode);
		formdata.append('country', country);

		let updtedLat = document.getElementById('updated_lat').value;
		let updtedLong = document.getElementById('updated_long').value;

		formdata.append('lat_add', updtedLat);
		formdata.append('lng_add', updtedLong);

		formdata.append('lat_pin', updtedLat);
		formdata.append('lng_pin', updtedLong);

		formdata.append('area_lat', '');
		formdata.append('area_long', '');

		var country1 = document.getElementById('selectCountry');
		var countryText = country1.options[country1.selectedIndex].text;

		var updatedAddress = '';
		if (streetAddress === '') {
			updatedAddress = pageLanguageContent['CLD083'] + city + ', ' + postalCode + ' ' + countryText;
		} else {
			updatedAddress = streetAddress + ' ' + city + ', ' + postalCode + ' ' + countryText;
		}
		let errorCount = validateErrors();
		if (errorCount <= 0) {
			setShowUpdateDataLoader(true);
			setShowHideLoader(true);
			copiriAxiosPost(config.portal_url, formdata)
				.then(response => {
					setLat(updtedLat);
					setLong(updtedLong);
					setShowUpdateDataLoader(false);
					setShowHideLoader(false);
					if (response?.data?.status === 'SUCCESS') {
						toast.success(pageLanguageContent['CLD119']);
						setDisabledUpdate(true);
						props.updateLodgeMap();
						props.closeLodgeAddressModal();
					}
				})
				.catch(error => {
					setShowHideLoader(false);
					props.closeLodgeAddressModal();
					setShowUpdateDataLoader(false);
				});
			//modalAddressField
			document.getElementById('lodgeModalAddressField').innerHTML = updatedAddress;
		}
	}

	/* function to validate errors*/

	function validateErrors() {
		let errors = { ...validation };
		var errorCount = 0;

		if (city === '') {
			errors.error_city = pageLanguageContent['CLD071'];
			errorCount++;
		} else {
			errors.error_city = '';
		}

		/*if (postalCode==='') {
			errors.error_postal_code = pageLanguageContent['CLD071'];
			errorCount++;
		} else {
			errors.error_postal_code = '';
		}*/

		if (country === '') {
			errors.error_country = pageLanguageContent['CLD071'];
			errorCount++;
		} else {
			errors.error_country = '';
		}
		setValidation(errors);
		return errorCount;
	}

	/* function to validate new address if provided */
	function validateAddress() {
		let checkValidationErrors = validateErrors();
		if (checkValidationErrors > 0) {
			return false;
		}
		var country1 = document.getElementById('selectCountry');
		var countryText = country1.options[country1.selectedIndex].text;
		// eslint-disable-next-line
		var stateText = '';
		var state1 = document.getElementById('selectState');
		if (state1) {
			stateText = state1.options[state1.selectedIndex].text;
		}

		const formdata = new FormData();
		formdata.append('action', 'address_validate');
		formdata.append('id', id);
		formdata.append('address_1', streetAddress);
		formdata.append('address_2', streetAddress2);
		formdata.append('address_3', streetAddress3);
		formdata.append('city', city);
		if (!checkStateData) {
			formdata.append('state_tt', state2);
			formdata.append('state_dd', '');
		} else {
			formdata.append('state_tt', '');
			formdata.append('state_dd', state);
		}
		formdata.append('post_code', postalCode);
		formdata.append('country', countryText);
		setShowHideLoader(true);
		setShowValidateLoader(true);
		setLat('');
		setLong('');
		copiriAxiosPost(config.portal_url, formdata)
			.then(response => {
				var i;
				if (response.data.status === 'OK') {
					setDisabledUpdate(false);
					setOrgName(response.data.results[0]['formatted_address']);
					let lat = '';
					let lng = '';
					if (response.data.results[1]) {
						lat = response.data.results[1]['geometry']['location']['lat'];
						lng = response.data.results[1]['geometry']['location']['lng'];
					} else {
						lat = response.data.results[0]['geometry']['location']['lat'];
						lng = parseFloat(response.data.results[0]['geometry']['location']['lng']);
					}
					document.getElementById('updated_lat').value = lat;
					document.getElementById('center_lat').value = lat;
					document.getElementById('updated_long').value = lng;
					document.getElementById('center_long').value = lng;
					setLat(lat); // set center lat
					setLong(lng); // set center long
					for (i = 0; i < response.data.results[0]['address_components'].length; i++) {
						if (postalCode === '') {
							if (response.data.results[0]['address_components'][i]['types'][0] === 'postal_code') {
								setPostalCode(response.data.results[0]['address_components'][i]['long_name']);
							}
						}
						if (!checkStateData) {
							if (response.data.results[0]['address_components'][i]['types'][0] === 'administrative_area_level_1') {
								setState2(response.data.results[0]['address_components'][i]['long_name']);
							}
						}
					}
					L.tileLayer
						.colorFilter('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
							attribution: null,
							transparent: true,
							url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
							filter: filter
						})
						.addTo(map.current.leafletElement);
					map.invalidateSize();
					setShowValidateLoader(false);
					updateCitLocation(city, countryText);
					setShowHideLoader(false);
				} else {
					toast.error(pageLanguageContent['CLD078']);
				}
			})
			.catch(error => {
				setShowHideLoader(false);
				setShowValidateLoader(false);
			});

		enableDisableValidate(true);
	}
	/* request city_geolocation API when address changes*/
	function updateCitLocation(city, countryText) {
		const formdata = new FormData();
		formdata.append('action', 'city_geolocation');
		formdata.append('city', city);
		formdata.append('country', countryText);
		copiriAxiosPost(config.portal_url, formdata)
			.then(response => {})
			.catch(error => {
				setShowHideLoader(false);
			});
	}

	//changeFacilityName
	const changeFacilityName = event => {
		setName(event.target.value);
		if (event.target.value === '') {
			setDisabledUpdate(true);
		} else {
			setDisabledUpdate(false);
		}
	};
	/* function to get the value of street 1*/
	const changeAddress1 = event => {
		setStreetAddress(event.target.value);
		setDisableStreet2(false);
		if (event.target.value === '') {
			setDisableStreet2(true);
			setDisableStreet3(true);
			setStreetAddress2('');
			setStreetAddress3('');
			setDisabledUpdate(true);
		} else {
			setDisabledUpdate(false);
		}
		enableDisableValidate();
	};
	/* function to get the value of street 2*/
	const changeAddress2 = event => {
		setStreetAddress2(event.target.value);
		setDisableStreet3(false);
		if (event.target.value === '') {
			setDisableStreet3(true);
			setStreetAddress3('');
			setDisabledUpdate(true);
		} else {
			setDisabledUpdate(false);
		}
		enableDisableValidate();
	};

	/* function to get the value of street 3*/
	const changeAddress3 = event => {
		setStreetAddress3(event.target.value);
		enableDisableValidate();
		if (event.target.value === '') {
			setDisabledUpdate(true);
		} else {
			setDisabledUpdate(false);
		}
	};

	/* function to get the value of city input box*/
	const changeCity = event => {
		setCity(event.target.value);
		enableDisableValidate();
	};

	/* function to get the value of postal code input box*/
	const changePostal = event => {
		setPostalCode(event.target.value);
		enableDisableValidate();
	};

	/* function to get the value of state input box*/
	const changeState = event => {
		setState(event.target.value);
		enableDisableValidate();
	};

	/* function to get the value of state2 input box if coutnry's state not found, then user can manual enter */
	const changeState2 = event => {
		setState2(event.target.value);
		enableDisableValidate();
	};

	function enableDisableValidate(disableValidate = false) {
		if (disableValidate) {
			setDisabledValidate(true);
			setRevalidateMessage(false);
		} else {
			setDisabledValidate(false);
			setRevalidateMessage(true);
		}
	}

	function updatePosition(newLat, newLong, flag) {
		document.getElementById('updated_lat').value = newLat;
		document.getElementById('updated_long').value = newLong;
		setDisabledUpdate(flag);
		setLat(newLat);
		setLong(newLong);
	}

	const eventHandlersEnd = event => {
		setLat(event.target._latlng.lat);
		setLong(event.target._latlng.lng);
		setDcColor('transparent');
		document.getElementById('closerPin').innerHTML = '';
	};

	/* trigger function when map pin moves */
	const eventHandlers = event => {
		var distance = getDistance([lat, long], [event.target._latlng.lat, event.target._latlng.lng]);
		document.getElementById('cordinates').innerHTML =
			Number(event.target._latlng.lat).toFixed(4) + ' ,' + Number(event.target._latlng.lng).toFixed(4);
		//cordinates
		setDisabledUpdate(false);
		if (distance >= 101) {
			setDcColor('black');
			document.getElementById('confirmValidatebutton').disabled = true;
			document.getElementById('updateAddrees').innerHTML = pageLanguageContent['CLD113'];
			document.getElementById('newLat').innerHTML = event.target._latlng.lat;
			document.getElementById('newLong').innerHTML = event.target._latlng.lng;
			document.getElementById('closerPin').innerHTML = pageLanguageContent['CLD133'];
			setDcColor('black');
		} else {
			document.getElementById('confirmValidatebutton').disabled = false;
			document.getElementById('updateAddrees').innerHTML = pageLanguageContent['CLD113'];
			document.getElementById('newLat').innerHTML = event.target._latlng.lat;
			document.getElementById('newLong').innerHTML = event.target._latlng.lng;
			document.getElementById('closerPin').innerHTML = '';
			setDcColor('transparent');
		}
	};

	/* function to get distance when pin moves*/
	function getDistance(origin, destination) {
		// return distance in meters
		var lon1 = toRadian(origin[1]),
			lat1 = toRadian(origin[0]),
			lon2 = toRadian(destination[1]),
			lat2 = toRadian(destination[0]);
		var deltaLat = lat2 - lat1;
		var deltaLon = lon2 - lon1;
		var a = Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(deltaLon / 2), 2);
		var c = 2 * Math.asin(Math.sqrt(a));
		var EARTH_RADIUS = 6371;
		return c * EARTH_RADIUS * 1000;
	}
	// return degree
	function toRadian(degree) {
		return (degree * Math.PI) / 180;
	}

	return (
		<div>
			<Modal show={props.showHide} onHide={props.closeLodgeAddressModal} id='addresModal'>
				<ModalHeader onHide={props.closeModal}>
					<Modal.Title>{pageLanguageContent['CLD128'] ? pageLanguageContent['CLD128'] : ''}</Modal.Title>
				</ModalHeader>
				<ModalBody>
					<Form>
						<Row>
							<Col lg={12}>
								<FormGroupInput
									id='building-name'
									label={pageLanguageContent['CLD050'] ? pageLanguageContent['CLD050'] : ''}
									placeholder={pageLanguageContent['CLD186'] ? pageLanguageContent['CLD186'] : ''}
									onChange={changeFacilityName}
									value={name}
									type='text'
								/>
								<span className='formValidationError'>{nameError}</span>
							</Col>

							<Col lg={12}>
								<FormGroupInput
									id='street-address'
									label={pageLanguageContent['CLD051'] ? pageLanguageContent['CLD051'] : ''}
									placeholder={pageLanguageContent['CLD051'] ? pageLanguageContent['CLD051'] : ''}
									value={streetAddress}
									onChange={changeAddress1}
									type='text'
								/>
								<span className='formValidationError'>{streetAddressError}</span>
							</Col>

							<Col lg={12}>
								<FormGroupInput
									id='street-address-line-2'
									label={pageLanguageContent['CLD052'] ? pageLanguageContent['CLD052'] : ''}
									placeholder={pageLanguageContent['CLD052'] ? pageLanguageContent['CLD052'] : ''}
									value={streetAddress2}
									onChange={changeAddress2}
									type='text'
									disabled={disableStreet2}
								/>
							</Col>

							<Col lg={12}>
								<FormGroupInput
									id='street-address-line-3'
									label={pageLanguageContent['CLD053'] ? pageLanguageContent['CLD053'] : ''}
									placeholder={pageLanguageContent['CLD053'] ? pageLanguageContent['CLD053'] : ''}
									value={streetAddress3}
									onChange={changeAddress3}
									type='text'
									disabled={disableStreet3}
								/>
							</Col>

							<Col lg={6}>
								<FormGroupInput
									id='city'
									label={pageLanguageContent['CLD054'] ? pageLanguageContent['CLD054'] : ''}
									placeholder={pageLanguageContent['CLD054'] ? pageLanguageContent['CLD054'] : ''}
									value={city}
									onChange={changeCity}
									type='text'
								/>
								{validation.error_city && <p className='formValidationError'>{validation.error_city}</p>}
							</Col>

							<Col lg={6}>
								<FormGroupInput
									id='postal-code'
									label={pageLanguageContent['CLD055'] ? pageLanguageContent['CLD055'] : ''}
									placeholder={pageLanguageContent['CLD055'] ? pageLanguageContent['CLD055'] : ''}
									value={postalCode}
									onChange={changePostal}
									type='text'
								/>
								{validation.error_postal_code && <p className='formValidationError'>{validation.error_postal_code}</p>}
							</Col>

							<Col lg={6}>
								<Form.Group className='form-group'>
									<Form.Label for='lodgeCountry'>
										{pageLanguageContent['CLD056'] ? pageLanguageContent['CLD056'] : ''}
									</Form.Label>
									<select className='form-control' value={country} onChange={changeCountry} id='selectCountry'>
										<option value=''>{pageLanguageContent['CLD056'] ? pageLanguageContent['CLD056'] : ''}</option>
										{countryData.length > 0 &&
											countryData.map((item, i) => (
												<>
													{item?.id ? (
														<option value={item.id} key={item.id}>
															{item.name}
														</option>
													) : (
														<option>---</option>
													)}
												</>
											))}
									</select>
								</Form.Group>
								{validation.error_country && <p className='formValidationError'>{validation.error_country}</p>}
							</Col>

							<Col md={6}>
								<Form.Group className='form-group'>
									<Form.Label for='lodgeState'>
										{pageLanguageContent['CLD057'] ? pageLanguageContent['CLD057'] : ''}
									</Form.Label>
									{checkStateData ? (
										<>
											<select className='form-control' onChange={changeState} value={state} id='selectState'>
												<option value=''>{pageLanguageContent['CLD185'] ? pageLanguageContent['CLD185'] : ''}</option>
												{stateData.length > 0 &&
													stateData.map((item, i) => (
														<option value={item.id} key={item.id}>
															{item.name}
														</option>
													))}
											</select>
										</>
									) : (
										<input
											type='text'
											name='state'
											id='state'
											placeholder=''
											onChange={changeState2}
											value={state2}
											className='form-control'
										/>
									)}
								</Form.Group>
								{validation.error_state && <p className='formValidationError'>{validation.error_state}</p>}
							</Col>
							<Col md={6}>
								{revalidateMessage ? (
									<p className='text-danger address_error'>
										{pageLanguageContent['CLD059'] ? pageLanguageContent['CLD059'] : ''}
									</p>
								) : (
									''
								)}
							</Col>
							<Col md={6} className='text-right'>
								<Button
									variant='primary'
									className='btn pull-right btn-primary btn-success'
									onClick={validateAddress}
									disabled={disabledValidate}
								>
									{showValidateLoader ? (
										<img src={loader_image} alt={genPageData['GENLDG'] ? genPageData['GENLDG'] : ''} width='20px' height='20px' />
									) : (
										<>{pageLanguageContent['CLD058'] ? pageLanguageContent['CLD058'] : ''}</>
									)}
								</Button>
							</Col>
						</Row>
					</Form>
					<Row>
						<Col md={12}>
							<hr />
						</Col>
					</Row>

					{lat && long && (
						<p style={{ fontSize: '12px' }}>
							<b>
								{pageLanguageContent['CLD060'] ? pageLanguageContent['CLD060'] : ''}:{' '}
								<span id='cordinates'>
									{parseFloat(lat).toFixed(4)}, {parseFloat(long).toFixed(4)}
								</span>
							</b>
						</p>
					)}

					<input type='hidden' id='updated_lat' value={lat} />
					<input type='hidden' id='updated_long' value={long} />
					<input type='hidden' id='center_lat' />
					<input type='hidden' id='center_long' />

					<p>
						<b>{pageLanguageContent['CLD061'] ? pageLanguageContent['CLD061'] : ''}:</b>{' '}
						{pageLanguageContent['CLD062'] ? pageLanguageContent['CLD062'] : ''}
					</p>

					{lat && long ? (
						<AddressMap
							lat={lat}
							long={long}
							dragMap={eventHandlers}
							dragEndMap={eventHandlersEnd}
							dcolor={dcolor}
							orgName={orgName}
							pageLanguageContent={pageLanguageContent}
							updatePosition={updatePosition}
							map={map}
						/>
					) : null}
				</ModalBody>
				<ModalFooter>
					<p
						style={{ position: 'absolute', left: '10px', color: 'red', width: '50%', fontSize: '11px' }}
						id='closerPin'
					></p>
					<Button variant='secondary' onClick={props.closeLodgeAddressModal} id='closeAddressModal'>
						{genPageData['GENCNC'] ? genPageData['GENCNC'] : ''}
					</Button>
					<Button variant='primary' id={'confirmValidatebutton'} onClick={updateAddress} disabled={disabledUpdate}>
						{showUpdateDataLoader ? (
							<img src={loader_image} alt={genPageData['GENLDG'] ? genPageData['GENLDG'] : ''} width='20px' height='20px' />
						) : (
							<>{pageLanguageContent['CLD063'] ? pageLanguageContent['CLD063'] : ''}</>
						)}
					</Button>
					<span id='updateAddrees' className='hiden'></span>
					<span id='newLat' className='hiden'></span>
					<span id='newLong' className='hiden'></span>
				</ModalFooter>
			</Modal>
		</div>
	);
};

export default LodgeAddressModal;
